import { gql } from "@apollo/client";

const metadataFields = `
  value
  count
  formattedValue
`;

const ATS_RESULT_FILTER_METADATA = gql`
  fragment MissionRoleParticipantResultFilterMetadata on MissionRoleParticipantResultFilterMetadata {
    archetype {
      ${metadataFields}
    }
    continent {
      ${metadataFields}
    }
    country {
      ${metadataFields}
    }
    disciplines {
      ${metadataFields}
    }
    matchingSkills {
      ${metadataFields}
    }
    matchingSkillsOptional {
      ${metadataFields}
    }
    matchingSkillsRequired {
      ${metadataFields}
    }
    missionRoleApplicantState {
      ${metadataFields}
    }
    missionBoardActiveApplicationRoles {
      ${metadataFields}
    }
    missionRoleApplicantNoticePeriod {
      ${metadataFields}
    }
    missionRoleArchetypes {
      ${metadataFields}
    }
    missionRoleSkills {
      ${metadataFields}
    }
    missionRoleSkillsOptional {
      ${metadataFields}
    }
    missionRoleSkillsRequired {
      ${metadataFields}
    }
    missionRoleTimeZone {
      ${metadataFields}
    }
    otherSkills {
      ${metadataFields}
    }
    partner {
      ${metadataFields}
    }
    skills {
      ${metadataFields}
    }
    talentOwner {
      ${metadataFields}
    }
    timeZone {
      ${metadataFields}
    }
    worldRegion {
      ${metadataFields}
    }
  }
`;

export { ATS_RESULT_FILTER_METADATA };
